import { TranslationLanguage } from "@redotech/cockroachdb-codegen/tables/returns/translation-language";
import * as z from "zod";
import { TRANSLATION_SOURCES } from "./set-flow-element-translations";

/**
 * The team's saved translations for the given flow elements (multiple choice
 * steps and options, by their stable uuid), across all languages — the flow
 * editor's read for its per-language text panels.
 */
export const getFlowElementTranslations = {
  name: "getFlowElementTranslations" as const,
  input: z.object({ elementIds: z.array(z.string().max(100)).max(200) }),
  output: z.object({
    translations: z.array(
      z.object({
        elementId: z.string(),
        field: z.string(),
        language: z.enum(TranslationLanguage),
        text: z.string(),
        source: z.enum(TRANSLATION_SOURCES),
      }),
    ),
  }),
};
